import {
  UnifiedProfileQuery,
  UnifiedProfileQuery$data,
} from 'graphql/__generated__/UnifiedProfileQuery.graphql';
import { useLazyLoadQuery, readInlineData } from 'react-relay';
import { Redirect, usePathParam } from 'react-resource-router';
import useValidateProfileIdPath from 'utils/useValidateUsernamePath';
import PrivateProfile from './PrivateProfile';
import TopPanel from '../top-panel/TopPanel';
import { UNIFIED_PROFILE_QUERY } from 'graphql/UnifiedProfileQuery';
import { ErrorBoundary } from 'react-error-boundary';
import Fallback from 'components/common/fallback/Fallback';
import { logBoundaryError } from 'services/logger';
import useIsPersonalView from 'utils/useIsPersonalView';
import { UnifiedProfileFragment$key } from 'graphql/__generated__/UnifiedProfileFragment.graphql';
import { UNIFIED_PROFILE_FRAGMENT } from 'graphql/UnifiedProfileFragment';
import { MainContentContainer, CoverImage, MainContent } from '../Profile';

const PrivateProfileComponent = ({
  children,
}: {
  children: JSX.Element;
}): JSX.Element => {
  const [internalId = ''] = usePathParam('pathProfileId');
  const isValid = useValidateProfileIdPath();

  if (!isValid) {
    return <Redirect to="/error/invalid_path" />;
  }

  const unifiedProfileData = useLazyLoadQuery<UnifiedProfileQuery>(
    UNIFIED_PROFILE_QUERY,
    { internalId },
  );

  const unifiedProfile = unifiedProfileData?.unified?.unifiedProfile;

  const profileData =
    unifiedProfile && `__fragments` in unifiedProfile
      ? readInlineData<UnifiedProfileFragment$key>(
          UNIFIED_PROFILE_FRAGMENT,
          unifiedProfile as NonNullable<
            UnifiedProfileQuery$data['unified']
          >['unifiedProfile'],
        )
      : null;

  const isPersonalView = useIsPersonalView(internalId);
  const showPrivateProfileMessage = !isPersonalView && profileData?.isPrivate;

  if (showPrivateProfileMessage)
    return (
      <div>
        <CoverImage />
        <MainContentContainer>
          <ErrorBoundary
            FallbackComponent={Fallback}
            onError={logBoundaryError}
          >
            <TopPanel />
          </ErrorBoundary>
          <MainContent>
            <PrivateProfile />
          </MainContent>
        </MainContentContainer>
      </div>
    );

  return children;
};
export default PrivateProfileComponent;
